import React from 'react';
import { Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { InfoOutlined as InfoOutlinedIcon } from '@material-ui/icons';

const useStyles = makeStyles({
    tooltip: {
        fontSize: '1.05rem',
    },
});

export interface DescriptionCellProps {
    description: string;
    validationErrors?: string[];
    errorIconClassName?: string;
}

const DescriptionCell: React.FC<DescriptionCellProps> = ({
    description,
    validationErrors,
    errorIconClassName,
}) => {
    const classes = useStyles();
    const hasErrors = validationErrors && validationErrors.length > 0;
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{description}</span>
            {hasErrors && (
                <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    title={
                        <div>
                            <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: 4, color: '#fff' }}>
                                Validation Warnings:
                            </Typography>
                            <ul style={{ margin: 0, paddingLeft: 20 }}>
                                {validationErrors!.map((err: string, idx: number) => (
                                    <li key={idx}>
                                        <Typography variant="body2" style={{ color: '#fff' }}>
                                            {err}
                                        </Typography>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    }
                    arrow
                    placement="right"
                >
                    <InfoOutlinedIcon className={errorIconClassName} />
                </Tooltip>
            )}
        </div>
    );
};

function arePropsEqual(prev: DescriptionCellProps, next: DescriptionCellProps): boolean {
    if (prev.description !== next.description) return false;
    const prevLen = prev.validationErrors?.length ?? 0;
    const nextLen = next.validationErrors?.length ?? 0;
    if (prevLen !== nextLen) return false;
    return true;
}

export default React.memo(DescriptionCell, arePropsEqual);
